import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import GoodFaithCheckbox from '../../../formFields/GoodFaithCheckbox';
import AccurateInformationCheckbox from '../../../formFields/AccurateInformationCheckbox';
import AcceptsLiabilityCheckbox from '../../../formFields/AcceptsLiabilityCheckbox';
import UnderstandsNotificationForwardingCheckbox from '../../../formFields/UnderstandsNotificationForwardingCheckbox';
import AcceptsPossibleAccountTerminationCheckbox from '../../../formFields/AcceptsPossibleAccountTerminationCheckbox';
import ConsentsToJurisdictionCheckbox from '../../../formFields/ConsentsToJurisdictionCheckbox';
import UnderstandsSueabilityCheckbox from '../../../formFields/UnderstandsSueabilityCheckbox';

interface Props {}

const CopyrightCounterCheckboxes: FC<Props> = () => {
  const { t } = useTranslation('contact');
  return (
    <>
      <GoodFaithCheckbox
        label={t('contact:dmcaForm.legalBlock.counterClaim.goodFaithCheckbox.label')}
        required
      />
      <AccurateInformationCheckbox
        label={t('contact:dmcaForm.legalBlock.counterClaim.accurateInformationCheckbox.label')}
        required
      />

      <AcceptsLiabilityCheckbox required />
      <ConsentsToJurisdictionCheckbox required />
      <UnderstandsNotificationForwardingCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.counterClaim.understandsNotificationForwardingCheckbox.label'
        )}
        required
      />
      <AcceptsPossibleAccountTerminationCheckbox
        label={t(
          'contact:dmcaForm.legalBlock.counterClaim.acceptsPossibleAccountTermination.label'
        )}
        required
      />
      <UnderstandsSueabilityCheckbox required />
    </>
  );
};

CopyrightCounterCheckboxes.displayName = 'CopyrightCounterCheckboxes';

export default CopyrightCounterCheckboxes;
